var map = {
	"./Jade_Round_White_Top_1.jpeg": 52,
	"./MP_Round_White_Top_1.jpeg": 53,
	"./Snake_Square_White_Front_1.jpeg": 109,
	"./Spider_Square_White_Top_1.jpeg": 110,
	"./circle.png": 40,
	"./jade_collection_1.jpeg": 111,
	"./square.png": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;